
<div class="header-slot">
  <ng-content select="[galaxy-card-header]"></ng-content>
</div>

<div class="content-slot">
  <ng-content select="[galaxy-card-content]"></ng-content>
</div> 

<div class="actions-slot">
  <ng-content select="[galaxy-card-actions]"></ng-content>
</div>
